<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Teklifler / {{this.offer_type.toUpperCase()}}</div>
                <div slot="actions">
					<actions v-if="getAuth.isAdmin" module="offers" :item="item" />
                    <v-btn tile color="indigo" dark @click="saveItem()">
                        <v-icon>{{mdiContentSave}}</v-icon> Kaydet
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Teklif bilgileri yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <v-container grid-list-md mt-3>
                        <v-layout wrap>
                            <v-flex md5 sm6 mb-3 >
                                <v-text-field label="Konu" v-model="item.title" outlined hide-details placeholder="Örn: Lanxess Germany"></v-text-field>
                            </v-flex>
                            <v-flex md3 sm6 mb-3>
                                <v-select v-model="item.user_id" :items="users" item-text="fullname" item-value="id" label="Teklif Sahibi" outlined>
									<template slot="selection" scope="data">
										{{ data.item.fullname }} <small class="text-muted" style="margin-left:10px;color:#999">{{data.item.company.firma_adi || data.item.email}}</small>
									</template>
									<template slot="item" scope="data">
										{{ data.item.fullname }} <small class="text-muted" style="margin-left:10px;color:#999">{{data.item.company.firma_adi || data.item.email}}</small>
									</template>
								</v-select>
                            </v-flex> 
                            <v-flex md2 sm4 mb-3>
                               <datepicker label="Düzenleme Tarihi"  v-model="item.date_edit_text" locale="tr-tr"/> 
                            </v-flex> 
                            <v-flex md2 sm4 mb-3>
                               <datepicker label="Geçerlilik Tarihi"  v-model="item.date_end_text" locale="tr-tr"/> 
                            </v-flex> 
                        </v-layout>
                    </v-container>
					<table class="table table-striped table-borderless table-hover">
                        <thead>
                            <tr>
                                <th style="width:1%;">No</th>
                                <th>ÜRÜN</th>
                                <th style="width:160px" v-for="i in item.price_titles_count" :key="'col'+i">
									<v-text-field dense v-model="item.price_titles[i-1]" outlined hide-details ></v-text-field> 
								</th>    
                                <!-- <th style="width:120px">KUR</th>   -->
                                <th style="width:1%;" class="actions">
									<v-btn small icon color="primary" dark @click="priceTitlesCountToggle()">
                                        <v-icon>{{mdiTableRowPlusBefore}}</v-icon>
                                    </v-btn>
								</th>
                                <th style="width:1%;" class="actions"></th>
                                <th style="width:1%;" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(entry, entryIndex) in item.entries" :key="entryIndex"  class="entryItem">
								<td>{{entryIndex + 1}}</td>
                                <td class="cell-detail">
                                    <v-autocomplete v-model="entry.product_id" :items="products" item-value="id" item-text="fullname" outlined hide-details="" dense 
									v-on:input="updateEntryProduct(entryIndex)"></v-autocomplete>
                                </td> 
                                <td v-for="i in item.price_titles_count" :key="'entry'+entryIndex+'col'+i"> 
									<template v-if="i==1">
										<inputtffloat v-model="entry.price"/> 
									</template>
									<template v-else>
										<inputtffloat v-model="entry.prices[i - 1]"/> 
									</template>
								</td> 
                                <td> 
									{{entry.kur}}
								</td> 
                                <td class="actions">
                                    <v-btn small icon color="primary" dark @click="addEntry(entryIndex)">
                                        <v-icon>{{mdiTableRowPlusBefore}}</v-icon>
                                    </v-btn>
                                </td>
                                <td class="actions">
                                    <v-btn small icon color="red" dark @click="removeEntry(entryIndex)">
                                        <v-icon>{{mdiCloseCircle}}</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
					<div class="text-center mb-4">
						<v-btn tile color="green" dark @click="addEntry()">
							<v-icon>{{mdiPlus}}</v-icon> Yeni Satır Ekle
						</v-btn>
					</div> 
					<v-container grid-list-md mt-3>
					<v-layout wrap>

						<v-flex md6 sm12 mb-3 >
							<v-textarea v-model="item.description" label="Açıklama" outlined rows="5" hide-details></v-textarea>
						</v-flex>
						<v-flex md6 sm12 mb-3 >
							<v-textarea v-model="item.conditions" label="Teklif Koşulları" outlined rows="5" hide-details></v-textarea>
						</v-flex>




					</v-layout>
                    </v-container>

                </template>
            </panelcontainer>



            <v-snackbar v-model="actionDialogShow" :color="actionDialogColor" :timeout="3000" top>
                {{ actionDialogText }}
                <v-btn dark text @click="actionDialogShow = false">
                    Tamam
                </v-btn>
            </v-snackbar>

        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import inputtffloat from "@/components/inputs/tffloat"
    import datepicker from "@/components/inputs/datepicker"
    import actions from "@/components/utils/actions"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiCalendarRange,
        mdiTableRowPlusBefore,
        mdiContentSave,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
            inputtffloat,
            datepicker,
            actions,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiCalendarRange: mdiCalendarRange,
            mdiTableRowPlusBefore: mdiTableRowPlusBefore,
            mdiContentSave: mdiContentSave,

			offer_type : "",
			
            isLoading: false,
            dialogEditor: false,
			dialogRemove: false,
			
            users: [ ], 
            products: [ ], 
			item: {}, 

			
            actionDialogShow: false,
            actionDialogText: "",
            actionDialogColor: "",
        }),
		mounted(){
			this.offer_type = this.$route.params.offer_type;
			this.item_id = this.$route.query.id || ""
			this.loadUsers() 
			this.loadProducts()  
			this.loadItem() 
		},
        methods: {
			loadUsers(){
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					this.users = response.body;  
				}) 
			},
			loadProducts(){
				this.$http.get( process.env.VUE_APP_API_URL + "/products/legit", {
					params : { }
				}).then(response => {
					this.products = response.body;  
				}) 
			}, 
			loadItem(){
				this.isLoading = true;
				if(this.item_id == ""){
					this.setNewItemData();
					this.isLoading = false; 
				}else{ 
					this.$http.get( process.env.VUE_APP_API_URL + "/offers/info", {
						params : { id : this.item_id, offer_type : this.offer_type }
					}).then(response => {
						this.item = response.body; 
						this.isLoading = false; 
					})  
				}
			},
			setNewItemData(){
				this.item = {
					id:"",
					title : "",
					user_id : 0,
					date_edit_text : "",
					date_end_text : "", 
					price_titles_count : 1,
					price_titles : ["Ön Ödeme","Peşin","120gün Vade","180gün Vade"],
					entries : [], 
					description : "Firmanızın istemiş olduğu ve bizim teklif etmeyi uygun bulduğumuz ürünler ile ilgili tamamen size özel olarak hazırlanmış olan ve onayınızdan büyük bir mutluluk duyacağımız fiyat teklifimiz aşağıda bilgilerinize sunulmuştur.Bu şartlar dahilinde söz konusu teklifimize olumlu cevaplarınızı bekler, değerli siparişlerinizi bekleriz.",
					conditions : "1.Fiyatlarımıza  Ötv dahil olup, nakliye ve kdv  dahil değildir,\n2.Fiyatlarımız birim Kg ile fiyatlandırılır,\n3.Fiyatlarımız ….. gün vade ile sınırlı olup TL ile yapılan tahsilatlarda tahsil vadesindeki kur esas alınır,\nSaygılarımızla",
				} 
				this.addEntry()
				this.addEntry()
			},
			addEntry(before){
				var entry = {
					product_id : 0,
					price : 0.0, 
					prices : [0.0,0.0,0.0,0.0,0.0], 
				}
				if(before === 0 || before > 0){
					this.item.entries.splice(before, 0, entry);
				}
				else{
					this.item.entries.push(entry)
				}
			},
			removeEntry(i){
				this.item.entries.splice(i, 1);
			},  
			priceTitlesCountToggle(){
				this.item.price_titles_count++;
				if(this.item.price_titles_count > 3){
					this.item.price_titles_count = 1;
				}
			},
			updateEntryProduct(entryIndex){
				if(this.item.entries[entryIndex].product_id){
					for(var i in this.products){
						if(this.products[i].id == this.item.entries[entryIndex].product_id){ 
							this.item.entries[entryIndex].price = this.products[i].price_sell
							this.item.entries[entryIndex].kur = this.products[i].kur
						}
					}
				}
			},
            saveItem() {
				this.isLoading = true; 
				this.item.offer_type = this.offer_type
				this.$http.post( process.env.VUE_APP_API_URL + "/offers/save", this.item).then(response => {  
					if(response.body.success){
						this.actionDialogShow = true;
						this.actionDialogText = "Kayıt başarılı"
						this.actionDialogColor = "green"
						this.$router.replace("/offers/"+this.offer_type+"/edit/?id="+response.body.id)
						setTimeout(()=>{
							location.reload();
						},500)
					}
					else{
						this.actionDialogShow = true;
						this.actionDialogText = response.body.reason
						this.actionDialogColor = "red" 
						this.isLoading = false;
					} 
				}) 
            }, 
        },
		computed:{
			getAuth(){
				return this.$store.getters.getAuth;
			}
		}
    }
</script>

<style>

</style>